<script>
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";

export default {
  components: {
    Vue3ChartJs
  },
  name: 'LeadStageChart',
  props: {
    chartData: { type: Object, required: true },
    chartConfig: { type: Object, required: true },
    title: { type: String, default: 'Lead Stage Distribution' },
    centerLabel: { type: String, default: 'Active Leads' },
    chartKey: { type: [String, Number], default: 0 }
  },
  emits: ['open-stage-leads']   // <-- declare event
}
</script>

<template>
<div class="card flex-fill" v-if="chartData && chartData.active_leads">
<!-- <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
<h5 class="mb-2">{{ title || 'Lead Stage Distribution' }}</h5>
</div> -->
<div class="card-body">
 <div class="chartjs-wrapper-demo position-relative mb-4">
 <vue3-chart-js :key="chartKey" v-bind="{ ...chartConfig }" height="180" class="chartjs-chart"/>
 <div class="position-absolute text-center attendance-canvas">
  <p class="fs-13 mb-1">{{ centerLabel || 'Active Leads' }}</p>
  <h3>{{ chartData.active_leads }}</h3>
 </div>
</div>
<h6 class="mb-3">Stages</h6>
<div class="d-flex flex-wrap">
 <div v-for="(stage, index) in chartData.stage_wise_lead_distribution" :key="index" class="col-6 d-flex align-items-center mb-2">
  <div class="d-flex align-items-center w-100">
   <i class="ti ti-circle-filled" :style="{ color: stage.color, marginRight: '6px' }"></i>
    <span class="f-13 me-2">{{ stage.stage }}</span>
    <a href="javascript:void(0);" @click="$emit('open-stage-leads', stage)">
     <span class="badge bg-light text-muted ms-auto"> {{ stage.count }} ({{ stage.percentage }}%) </span>
    </a>
    </div>
  </div>
</div>
</div>
</div>
</template>
